import React, { type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import { Icon } from "@purpur/icon";
import { errorFilled } from "@purpur/icon/assets/error-filled";
import c from "classnames/bind";

import styles from "./field-error-text.module.scss";

const cx = c.bind(styles);

export const ariaRelevantValues = [
  "additions text",
  "additions",
  "removals",
  "text",
  "all",
] as const;

export type FieldErrorTextProps = Omit<BaseProps, "aria-relevant" | "children"> & {
  children: ReactNode;
  negative?: boolean;
  ["aria-relevant"]?: (typeof ariaRelevantValues)[number];
};

const rootClassName = "purpur-field-error-text";

export const FieldErrorText = ({
  children,
  className,
  negative = false,
  ["aria-relevant"]: ariaRelevant = "additions text",
  ...props
}: FieldErrorTextProps) => (
  <div
    className={cx(className, rootClassName, {
      [`${rootClassName}--negative`]: negative,
    })}
    aria-live="assertive"
    aria-relevant={ariaRelevant}
    {...props}
  >
    <Icon svg={errorFilled} size="xs" className={cx(`${rootClassName}__icon`)} />
    {children}
  </div>
);
